import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { Colors } from '@/constants/colors';

export const DisclaimerFooter: React.FC = () => {
  return (
    <View pointerEvents="none" style={styles.container}>
      <Text style={styles.text}>Educational purposes only. Not financial advice.</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: Platform.OS === 'web' ? 8 : 6,
    alignItems: 'center',
  },
  text: {
    fontSize: 11,
    color: Colors.text.tertiary,
    opacity: 0.7,
  },
});


